import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { apiUrl } from "../../constants";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Divider,
  Grid,
  TextField,
  Stack,
  Snackbar,
  Alert
} from '@mui/material';
import { Helmet } from "react-helmet";
import { useSelector } from 'react-redux';
import useCheckToken from '../../hooks/useCheckToken';
import useExchangeToken from "../../hooks/useExchangeToken";

import WipMasterForm from './WipMasterForm';

function StandardSettingEdit(props) {
  const exchangeToken = useExchangeToken();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  // ค่าเริ่มต้น
  const [values, setValues] = useState({
    plant_id: '',
    factory: '',
    line: '',
    material_description: '',
    belt_scale_feed_rate: '',
    multihead_upper_limit: '',
    multihead_auto_pack: '',
    multihead_target_giveaway: '',
    multihead_target_pack: '',
    multihead_upper_weight: '',
    multihead_speed_target: '',
    multihead_df_weight: '',
    fg_std_percent_absorb_range:'',
    fg_std_percent_meat_yield_range:'',
    fg_std_percent_absorb:'',
    fg_std_percent_meat_yield:'',
    fg_kg_per_box:'',
    fg_bag_per_box:'',
    weight_per_piece_range: '',
    weight_per_piece: '',
    check_on: ''
  });

  const [originalValues, setOriginalValues] = useState(null);

  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [error, setError] = useState(null);

  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);

  const toNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const s = v.trim().replace(/,/g, '');
      return s === '' ? 0 : Number(s) || 0;
    }
    return Number(v) || 0;
  };

  const defaultRange = (v) => {
    if (v === null || v === undefined) return '0-0';
    if (typeof v === 'string') {
      const s = v.trim();
      return s === '' ? '0-0' : s;
    }
    if (typeof v === 'number') {
      return `${v}-${v}`;
    }
    return String(v);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues(v => ({ ...v, [name]: value }));
  };

  const handleNumericBlur = (key) => (e) => {
    const n = toNumber(e.target.value);
    setValues(v => ({ ...v, [key]: n }));
  };

  useEffect(() => {
    const exchange = async () => {
      if (!isTokenExchanged) {
        try {
          await exchangeToken();
          setIsTokenExchanged(true);
        } catch (err) {
          console.error("Error exchanging token:", err);
          setError("Failed to exchange token");
        }
      }
    };
    exchange();
  }, [isTokenExchanged, exchangeToken]);

  useEffect(() => {
    if (!(isTokenExchanged && ac_token) || sessionStorage.getItem('master_std_plant') === '4179') return;

    async function fetchMyAPI() {
      try {
        const url_string = window.location.href;
        const url = new URL(url_string);
        const id = Number(url.searchParams.get("id"));
        const factory_code = sessionStorage.getItem('master_std_factory') === '1' ? '1' : sessionStorage.getItem('master_std_factory') === '00000000000001' ? '00000000000001' :'00000000000000'

        const urls = `${apiUrl.GET_MASTER_STD}get/${sessionStorage.getItem('master_std_plant')}/${factory_code}/`;
        const result = await axios.get(urls, {
          headers: { Authorization: `Bearer ${ac_token}` }
        });

        const row = (result.data || []).find(i => i.id === id);
        if (!row) return;


        const ul = toNumber(row.multihead_upper_limit);
        const tp = toNumber(row.multihead_target_pack);
        const initial = { ...row, multihead_upper_weight: ul + tp };

        setValues(initial);
        setOriginalValues(initial); 
      } catch (e) {
        console.log("Error fetching user:", e);
      }
    }

    fetchMyAPI();
  }, [ac_token, isTokenExchanged]);

  useEffect(() => {
    const ul = toNumber(values.multihead_upper_limit);
    const tp = toNumber(values.multihead_target_pack);
    const sum = ul + tp;

    if (values.multihead_upper_weight !== sum) {
      setValues(v => ({ ...v, multihead_upper_weight: sum }));
    }
  }, [values.multihead_upper_limit, values.multihead_target_pack]);

  const normalizeForApi = (vals) => ({
    belt_scale_feed_rate: toNumber(vals.belt_scale_feed_rate),
    multihead_upper_limit: toNumber(vals.multihead_upper_limit),
    multihead_auto_pack: toNumber(vals.multihead_auto_pack),
    multihead_target_giveaway: toNumber(vals.multihead_target_giveaway),
    multihead_target_pack: toNumber(vals.multihead_target_pack),
    multihead_speed_target: defaultRange(vals.multihead_speed_target),
    multihead_df_weight: toNumber(vals.multihead_df_weight),
    fg_std_percent_absorb_range: defaultRange(vals.fg_std_percent_absorb_range),
    fg_std_percent_meat_yield_range: defaultRange(vals.fg_std_percent_meat_yield_range),
    fg_std_percent_absorb: toNumber(vals.fg_std_percent_absorb),
    fg_std_percent_meat_yield: toNumber(vals.fg_std_percent_meat_yield),
    fg_kg_per_box: toNumber(vals.fg_kg_per_box),
    fg_bag_per_box: toNumber(vals.fg_bag_per_box),
    weight_per_piece_range: defaultRange(vals.weight_per_piece_range),
    weight_per_piece: toNumber(vals.weight_per_piece),
    channel: 'admin',
    multihead_upper_weight:
      toNumber(vals.multihead_upper_limit) + toNumber(vals.multihead_target_pack),
  });

  const handleSubmit = async () => {
    if (!originalValues) {
      console.log("originalValues ยังไม่ถูกโหลด");
      return;
    }

    const normCurrent = normalizeForApi(values);
    const normOriginal = normalizeForApi(originalValues);

    const diff = {};
    Object.keys(normCurrent).forEach(key => {

      if (normCurrent[key] !== normOriginal[key]) {
        diff[key] = normCurrent[key];
      }
    });


    if (Object.keys(diff).length === 0) {
      console.log("ไม่มีการเปลี่ยนแปลง — ไม่ต้องส่งไป API");
      setOpen(true); 
      return;
    }

    if (!diff.check_on && values.check_on) {
      diff.check_on = values.check_on;
    }

    console.log(diff);

    const url_edit = `${apiUrl.GET_MASTER_STD}update/${values.check_on}/`;

    try {
      const response = await axios.patch(url_edit, diff, {
        headers: { Authorization: `Bearer ${ac_token}` }
      });
      if (response.status === 200) {
        setOpen(true);
        setOriginalValues(values);
        setTimeout(() => {
          navigate(`/list-master-std`, { replace: true });
        }, 2000);
      } else {
        setOpen2(true);
      }
    } catch (error) {
      setOpen2(true);
      console.error(error);
    }
  };

  const handleBack = () => {
    navigate(`/list-master-std`, { replace: true });
  };

  if (sessionStorage.getItem('master_std_plant') === '4179') return <WipMasterForm edit />;

  return (
    <Box style={{ width: "100%", height: "93.5vh" }}>
      <Helmet>
        <title>Edit | MES </title>
      </Helmet>
      <form autoComplete="off" noValidate {...props}>
        <Stack spacing={2} sx={{ width: '100%' }}>
          <Snackbar open={open} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <Alert severity="success" sx={{ width: '100%' }}>
              The changes have been saved successfully.
            </Alert>
          </Snackbar>
          <Snackbar open={open2} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <Alert severity="error" sx={{ width: '100%' }}>
              Failed to save changes.
            </Alert>
          </Snackbar>
        </Stack>

        <Card sx={{ ml: 2, mt: 2, mr: 2 }}>
          <Box sx={{ mb: 3, mt: 0, ml: 2 }}>
            <Typography color="textPrimary" style={{ fontSize: 56 }}>
              Edit Master STD
            </Typography>
            <Typography color="textSecondary" gutterBottom style={{ fontSize: 20 }}>
              The information can be edited
            </Typography>
          </Box>
          <Divider />

          <CardContent>
            <Grid container spacing={3}>
              {/* Disabled fields */}
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth disabled label="Plant" name="plant_id"
                  onChange={handleChange}
                  value={values.plant_id}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth disabled label="Factory" name="factory"
                  onChange={handleChange}
                  value={values.factory}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth disabled label="Line" name="line"
                  onChange={handleChange}
                  value={values.line}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth disabled label="SKU" name="material_description"
                  onChange={handleChange}
                  value={values.material_description}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              {/* Editable numerics */}
              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="Production Capacity(kg/hr)"
                  name="belt_scale_feed_rate"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('belt_scale_feed_rate')}
                  required
                  value={values.belt_scale_feed_rate}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="MTH-Upper Limit(g)"
                  name="multihead_upper_limit"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('multihead_upper_limit')}
                  required
                  value={values.multihead_upper_limit}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth label="MTH-Std. Pack(g)"
                  name="multihead_auto_pack"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('multihead_auto_pack')}
                  required
                  value={values.multihead_auto_pack}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="MTH-Target Giveaway(%)"
                  name="multihead_target_giveaway"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('multihead_target_giveaway')}
                  required
                  value={values.multihead_target_giveaway}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="MTH-Setting Pack(g)"
                  name="multihead_target_pack"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('multihead_target_pack')}
                  required
                  value={values.multihead_target_pack}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              {/* Derived/disabled */}
              <Grid item md={6} xs={12}>
                <TextField
                  disabled type="number" fullWidth
                  label="MTH-Upper Weight(g)"   
                  name="multihead_upper_weight"
                  required
                  value={values.multihead_upper_weight ?? 0}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth label="MTH-Range Speed(Pack/min)"
                  name="multihead_speed_target"
                  onChange={handleChange}
                  required
                  value={values.multihead_speed_target}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="MTH-DF Weight(g)"
                  name="multihead_df_weight"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('multihead_df_weight')}
                  required
                  value={values.multihead_df_weight}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth label="Absorb range(%)"
                  name="fg_std_percent_absorb_range"
                  onChange={handleChange}
                  required
                  value={values.fg_std_percent_absorb_range}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth label="Meat yield range(%)"
                  name="fg_std_percent_meat_yield_range"
                  onChange={handleChange}
                  required
                  value={values.fg_std_percent_meat_yield_range}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="Avg. Absorb"
                  name="fg_std_percent_absorb"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('fg_std_percent_absorb')}
                  required
                  value={values.fg_std_percent_absorb}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="Avg. Meat yield(%)"
                  name="fg_std_percent_meat_yield"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('fg_std_percent_meat_yield')}
                  required
                  value={values.fg_std_percent_meat_yield}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="Box Weight(kg/box)"
                  name="fg_kg_per_box"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('fg_kg_per_box')}
                  required
                  value={values.fg_kg_per_box}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="Number of bags/box"
                  name="fg_bag_per_box"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('fg_bag_per_box')}
                  required
                  value={values.fg_bag_per_box}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth label="w/pc(Range)"
                  name="weight_per_piece_range"
                  onChange={handleChange}
                  required
                  value={values.weight_per_piece_range}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  type="number" fullWidth label="w/pc"
                  name="weight_per_piece"
                  onChange={handleChange}
                  onBlur={handleNumericBlur('weight_per_piece')}
                  required
                  value={values.weight_per_piece}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-input": { color: "#000000", fontFamily: 'CPF_Imm_Sook', fontSize: 18 } }}
                />
              </Grid>
            </Grid>
          </CardContent>

          <Divider />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
            <Button
              style={{ background: '#575755', color: "white", fontSize: 18 }}
              variant="contained"
              onClick={handleBack}
              sx={{ mr: 3 }}
            >
              Back to master std
            </Button>

            <Button
              style={{ background: '#009688', color: "white", fontSize: 18 }}
              variant="contained"
              onClick={handleSubmit}
            >
              Save details
            </Button>
          </Box>
        </Card>
      </form>
    </Box>
  );
}

StandardSettingEdit.propTypes = {};
export default StandardSettingEdit;
